import React from 'react';

import { ContentZonesService } from '@sm360/widget-commons-core-services';

const czGroup = 'widget.tradein';

const DealerLogo = () => {
    const cz = ContentZonesService.getContentZone(czGroup, 'dealer.logo');
    const czDealerLogo = cz ? cz.getValue() : null;
    return czDealerLogo ? (
        <div>
            <div className="DealerLogo">
                <div className="DealerLogo__logo">
                    <img src={czDealerLogo} alt="" />
                </div>
            </div>
        </div>
    ) : null;
};

DealerLogo.propTypes = {};

export default DealerLogo;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/DealerLogo.jsx